import Vue from 'vue'
import Router from 'vue-router'
import * as storage from "@/utils/sessionStorage"
import store from "../store"

//路由懒加载
const Login=()=>import('@/views/Login')
const Home=()=>import('@/views/Home')
const FoodList=()=>import('@/views/food/FoodList')
const SyncBind=()=>import('@/views/subManage/SyncBind')
const OrderingCodes = () => import('@/views/subManage/orderingCodes')
const SubjectManage=()=>import('@/views/subManage/SubjectManage')
const SubjectAdd=()=>import('@/views/subManage/SubjectAdd')
const SubjectDetail=()=>import('@/views/subManage/SubjectDetail')
const OpenCityList=()=>import('@/views/city/OpenCityList')
const VersionList=()=>import('@/views/appVer/VersionList')
const ConfigList=()=>import('@/views/sysConfig/ConfigList')
const AccountList=()=>import('@/views/account/AccountList')
const CameraList=()=>import('@/views/camera/CameraList')
const AccessControlList=()=>import('@/views/accessControl/accessControlList')
const switchList=()=>import('@/views/switch/switchList')
const Video=()=>import('@/views/camera/Video')
const CommentSetting = ()=>import('@/views/sysConfig/commentSetting')
const CommentList = ()=>import('@/views/commentList/list')
const ModuleList = ()=> import('@/views/moduleCollection/moduleList')
const ModuleAdd = ()=> import('@/views/moduleCollection/moduleAdd')
const ModuleDetail = ()=> import('@/views/moduleCollection/moduleDetail')
const ModuleEdit = ()=>import('@/views/moduleCollection/moduleEdit')
const HomeConfigList = ()=>import('@/views/sysConfig/homeConfigList')
const CompusList = ()=> import('@/views/province/CompusList')
const DiningRoomList = ()=>import('@/views/province/DiningRoomList')
const UserList = ()=>import('@/views/province/UserList')
const SupplierList = ()=> import('@/views/province/SupplierList')

Vue.use(Router)

let isLogin = storage.getCookie('is-login') === 'true';

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            children:[
                {path:'/foodList',name:'FoodList',component:FoodList},
                {path:'/syncBind',name:'SyncBind',component:SyncBind},
                {path: '/orderingCodes',name: 'OrderingCodes',component: OrderingCodes},
                {path:'/subjectManage',name:'SubjectManage',component:SubjectManage},
                {path:'/subjectAdd',name:'SubjectAdd',component:SubjectAdd},
                {path:'/subjectDetail',name:'SubjectDetail',component:SubjectDetail},
                {path:'/openCityList',name:'OpenCityList',component:OpenCityList},
                {path:'/versionList',name:'VersionList',component:VersionList},
                {path:'/configList',name:'ConfigList',component:ConfigList},
                {path:'/accountList',name:'AccountList',component:AccountList},
                {path:'/cameraList',name:'CameraList',component:CameraList},
                {path:'/accessControlList',name:'accessControlList',component:AccessControlList},
                {path:'/switchList',name:'switchList',component:switchList},
                {path:'/commentSetting', name:'CommentSetting', component:CommentSetting},
                {path:'/commentList', name:'CommentList', component:CommentList},
                {path:'/moduleList', name:'ModuleList', component:ModuleList},
                {path:'/moduleAdd', name:'ModuleAdd', component:ModuleAdd},
                {path:'/moduleDetail', name:'ModuleDetail', component:ModuleDetail},
                {path:'/moduleEdit', name:'ModuleEdit',component:ModuleEdit},
                {path:'/homeConfigList', name:'HomeConfigList',component:HomeConfigList},
                {path:'/compusList', name:'CompusList', component:CompusList},
                {path:'/diningRoomList', name:'DiningRoomList',component:DiningRoomList},
                {path:'/userList', name:'UserList',component:UserList},
                {path:'/supplierList', name:'SupplierList',component:SupplierList}
            ]
        },
        {
            path:'/login',name:'login',component:Login
        },
        {
            path:'/video',name:'Video',component:Video
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});

router.beforeEach((to, from, next) => {
    if (isLogin === true) { // 判断是否登录
      if (!store.state.user){
        (async function funName(){
          await store.dispatch('getUserInfo');
          next();
        }())
      } else {
        next()
      }
    // } else if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
    //   next();
    } else {
      if(!JSON.stringify(store.state.user) == '{}'){
        store.dispatch('goLogin')
      }
      next()
    }
});
  
router.afterEach((route) => {
    window.scrollTo(0, 0);//跳转另一页面是回到顶部
});

export function setLogin(flag) {
    isLogin = flag;
    storage.setCookie('is-login', flag);
}
  
export default router;
